import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { ApiHookProps } from '@/@types/api.types';
import { TransactionDetailsResponseDto } from '@/features/transactions/types/transactions-dto';
import {useAxiosAuth} from "@/hooks/useAxiosAuth.ts";

type Props = {} & ApiHookProps;

export const useTransactionDetailsApi = ({ id }: Props = {}) => {
    const axiosInstance = useAxiosAuth();
    const {
        data: transactionDetailsData, 
        isLoading: isLoadingTransactionDetailsData, 
        isError: isErrorTransactionDetailsData,       
    } = useQuery({
        queryKey: [
            ApiConfig.queries.features.transactions.queryKeys.details, 
            id
        ],
        queryFn: async (): Promise<TransactionDetailsResponseDto> => {
            const url = `${ApiConfig.queries.features.transactions.endpoints.get}/${id}`; 
            const response = await axiosInstance.get<TransactionDetailsResponseDto>(url);
            return response.data;
        },
        placeholderData: keepPreviousData,
        enabled: !!id,
    });

    return {
        transactionDetailsData,
        isLoadingTransactionDetailsData,
        isErrorTransactionDetailsData,       
    }
};
